export default "__VITE_ASSET__IxHEmGHK__"